import { replace } from './replace.ts'

export function add<T extends { name: string; children?: T[] }>(tree: T, parentNodeName: string, newNode: T) {
  return replace(tree, parentNodeName, (node) => {
    // eslint-disable-next-line no-param-reassign
    node.children = [...(node.children ?? []), newNode]
  })
}
